import { ArchiveFileLink } from '@components/archiveFileLink';
import { cn } from '@utils/helpers';
import { ChevronDownIcon } from 'lucide-react';
import type * as React from 'react';
import { useCallback, useEffect, useState } from 'react';
import type { ArchiveListMonthGroupPropsType } from './types';

const ArchiveListMonthGroup: React.FC<ArchiveListMonthGroupPropsType> = ({ documents, month, isVisible: isVisibleProp, isFirst }) => {
  const [isVisible, setIsVisible] = useState(isVisibleProp || isFirst);

  useEffect(() => {
    if (isVisibleProp || isFirst) {
      setIsVisible(true);
    }
  }, [isVisibleProp, isFirst]);

  const toggleVisibility = useCallback((e: any): void => {
    setIsVisible((prev) => !prev);
  }, []);

  return (
    <div className="pb-5 pl-10 max-[600px]:pl-2.5">
      <h5
        onClick={toggleVisibility}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            toggleVisibility(e);
          }
        }}
        className="cursor-pointer border-b border-[#ececec] pb-5 text-xl text-gray-500 flex items-center gap-6"
      >
        <span>{month}</span>
        <ChevronDownIcon className={cn('size-4 text-gray-500', isVisible && 'rotate-180')} />
      </h5>
      <div className="border-b border-[#ececec]">
        <div className={`grid overflow-hidden transition-[grid-template-rows] duration-300 ease-in-out ${isVisible ? 'grid-rows-[1fr]' : 'grid-rows-[0fr]'}`}>
          <div className="overflow-hidden">
            <div className="pl-[100px] max-[600px]:pl-2.5">
              {documents.map((archiveFileLink, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey : ok here
                <ArchiveFileLink key={index} archiveFileLink={archiveFileLink} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export { ArchiveListMonthGroup };
